import React from "react";
import {cs} from "@common/react/chain-services";
import {DropdownSelect2} from "@common/ui-components/dropdown-select/dropdown-select2";
import {rColumnValueSelectFromStepOutput} from "../../../../../common/column-value-select-from-step-output/column-value-select-from-step-output";
import {ffToDropdown} from "../../../../../../../../../../common/form/ff-to-dropdown";
import {keepOnly} from "@common/utils/objects";
import {rNewColumnNameInput} from "../../../common/new-column-name-input";

export const GetPartOfDateOperations = ({state, operation, form, inputStep, model}) =>
    cs(() => {
        const columnValueSelect = rColumnValueSelectFromStepOutput({
            columns: inputStep.outputColumns,
            model,
            disableStaticValue: true,
            filterColumnFn: (c) => ["DateTime", "DateTimeOffset"].includes(c.dataType),
            isValueNotAllowed: (c) => !["DateTime", "DateTimeOffset"].includes(c.dataType),
        });

        return (
            <>
                <div className="config-group">
                    <div className="label">Date Input Column</div>

                    {(() => {
                        const dropdownProps = ffToDropdown(form.field(["operation", "input"]));
                        return columnValueSelect({
                            state: {
                                value: dropdownProps.value,
                                onChange: dropdownProps.onChange,
                            },
                            ...keepOnly(dropdownProps, ["hasError", "errorMessage", "domRef"]),
                        });
                    })()}
                </div>

                <div className="config-group">
                    <div className="label">Date Part Unit</div>

                    {(() => {
                        const dropdownProps = ffToDropdown(form.field(["operation", "unit"]));

                        return DropdownSelect2({
                            label: "Unit",
                            list: ["Year", "Quarter", "Month", "DayOfMonth", "DayOfWeek", "DayOfYear", "WeekOfYear", "Hour", "Minute", "Second"],
                            isSelected: (v) => v === dropdownProps.value,
                            onChange: (v) => dropdownProps.onChange(v),
                            ...keepOnly(dropdownProps, ["hasError", "errorMessage", "domRef"]),
                        });
                    })()}
                </div>

                <div className="config-group">
                    <div className="label">New Column Name</div>

                    {rNewColumnNameInput({
                        form,
                        newColumnPath: ["operation", "newColumn"],
                        newColumnNamePath: ["operation", "newColumn", "name"],
                    })}
                </div>
            </>
        );
    });
